/**
 * Strip HTML tags → plain text for a doc/note card's body preview.
 *
 * Drive docs are stored as HTML; a card whose `bodyPreview` still carries markup
 * (an OLD persisted card, or a future emitter that forgot to strip) would render
 * raw tags like `<h1><strong>…` to the user. This is the render-time guarantee
 * that the card never shows markup — the mirror of the agent-side
 * `htmlToPreviewText` (apps/x-agent/src/features/tools/doc-preview.ts), which
 * cleans previews at emission. The two MUST stay in lockstep (web cannot import
 * the agent copy).
 *
 * The tag regex is anchored to a tag name (`<` + optional `/` + a letter) so a
 * literal `5 < 10 and 3 > 2` in prose is left intact — only real elements go.
 */
export function previewText(s: string | null | undefined): string {
  return String(s ?? '')
    .replace(/<\/?[a-zA-Z][^>]*>/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
